import http, {RequestOptions, noContent} from "@/api/http";

/** `POST /api/feedback` (#28, any user). 204. */
export const sendFeedback = (feedback: string, options?: RequestOptions): Promise<void> =>
    http.post("/feedback", {feedback}, options).then(noContent);
